<template>
  <div class="loading">
    <div class="progress"></div>
  </div>
</template>

<style lang="scss" scoped>
.loading {
  display: flex;
  position: fixed;
  z-index: 1031;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0.6rem;
}
.progress {
  width: 100%;
  height: 0.6rem;
  animation: progress-jgv380 2s infinite linear;
  background: linear-gradient(var(--color_primary) 0 0) left/0% 100% no-repeat
    var(--color_secondary_lighter);
}

@keyframes progress-jgv380 {
  100% {
    background-size: 100% 100%;
  }
}
</style>
